const _adminEstateRole = () => ["administrador", "gerente_agricola", "administrador_campo"];

export const reportRoutes = [];
